import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Form, Input, Row, Col,Select,DatePicker,Button,Pagination } from 'antd';
import {app} from '../../config';
import {CSVLink} from 'react-csv';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import { dateConverter } from '../../utils/utcDateConversion';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import useFetchOrganizationTypes from '../../hooks/fetchOrganizationTypes';
import useFetchStates from '../../hooks/fetchStates';
import useFetchCities from '../../hooks/fetchCities';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import NoRecordFound from '../../components/common/NoRecordFound';
// import logo from "../../../public/logo.png";

// import { faFileExcel } from '@fortawesome/free-solid-svg-icons'

const OrganizationsReport = () => {
  const { t } = useTranslation(['common']);
  let navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));
  const [form] = Form.useForm();
  const [reportObj, setReportObj] = useState({});
  const [getLIst,setGetList ] = useState(false);
  const [renderList,setRenderList] = useState([]);
  const [datatoExport,setDataToExport] = useState([]);
  const [pagesCount, setPagesCount] = useState(0);
  const [respList,setRespList] = useState([]);
  const [entriesCount,setEntriesCount] = useState(0);
  const [current,setCurrent] = useState(1);
  const [newObj,setNewObj] = useState([]);
  const token=getTokenfromUserObj()
  const orgTypeResp=useFetchOrganizationTypes();
  const orgTypes=orgTypeResp.response?orgTypeResp.response.data:[];
  console.log(orgTypes);
  const s=useFetchStates();
  const states=s.response?s.response.data:[];
  const c=useFetchCities();
  const cities=c.response?c.response.data:[];
  const o = useFetchOrganizations();
  const orgs = o.response ? o.response.data : [];
  console.log(orgs);
  const fetchData=async (obj)=>{
    console.log("fetchData")
    const limit=1000;
    const offset=0;
    obj.limit=limit;
    obj.offset=offset;

    const tr=await axios.post(`${app.URL}/report/organizations`,obj,{headers:{auth:token}});
    console.log(tr);
    tr.data?setCurrent(1):0;
    tr.data ? setRespList(tr.data.data) : console.log(0);
    tr.data ? setRenderList(tr.data.data) || setEntriesCount(tr.data.data.length) : []

    // tr.data?setRenderList(tr.data.data.slice(0,10))||setEntriesCount(tr.data.data.length):[]
  }
  let newStartDate;
  let newEndDate;
  const onFinish = (values) => {
    console.log('Success:', values);
    setReportObj({
      organizationTypeId: values.organizationTypeId ? values.organizationTypeId :null,
      stateId: values.stateId? values.stateId :null,
      cityId: values.cityId? values.cityId :null,
    });



  };
  console.log(reportObj);
 
  



  useEffect(()=>{
    if(Object.keys(reportObj).length>0)fetchData(reportObj);
  },[reportObj]);
  
  
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  useEffect(() => {
    const transList=async()=>{
      const user = JSON.parse(localStorage.getItem('user'));
      // if (user.userType === 'A') setEditBtn('block');
      const limit=1000;
      const offset=0;
      const tranResp=await axios.post(`${app.URL}/report/organizations`,{limit,offset},{headers:{auth:token}});
      console.log("🚀 ~ file: Users.js:31 ~ userList ~ userResp", tranResp.data.data.length)
      const convertedData= tranResp.data?dateConverter(tranResp.data.data,'donationDate'):console.log("done");
      tranResp.data?setRespList(convertedData):console.log(0);
      console.log(tranResp.data.data.length)
      // tranResp.data?setRenderList((convertedData).slice(0,10))||setEntriesCount(tranResp.data.data.length)||setDataToExport(tranResp.data.data):[]
      tranResp.data ? setRenderList(convertedData) || setEntriesCount(tranResp.data.data.length) || setDataToExport(tranResp.data.data) : []

      // userResp.data?setFetchUsers(userResp.data.data):" ";

      // userResp.data?setRenderList(userResp.data.data):" ";
    }
    transList();
    }, [getLIst]);
    const handleClearClick = () => {
      form.resetFields();
      setGetList(true)
    };
    console.log(entriesCount);
    const onChange = async(page) => {
      console.log(page);
      setCurrent(page);
      let limit=10;
      let reqObj={
        limit,
        offset:(page-1)*limit,
      }
      const newRender=respList.slice((page-1)*limit,page*limit);
      console.log(newRender);
      setRenderList(newRender);
    };
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    console.log(timeZone);
    console.log(renderList);
  return (
        // <div class='container w-100'>
        //   <div class='row mt-5'>
        //     <Form
        //       name='basic'
        //       labelCol={{
        //         span: 8,
        //       }}
        //       wrapperCol={{
        //         span: 8,
        //       }}
        //       style={{ alignItems: 'flexEnd' }}
        //       initialValues={{
        //         remember: true,
        //       }}
        //       onFinish={onFinish}
        //       onFinishFailed={onFinishFailed}
        //       autoComplete='off'
        //     >
        //       <Row gutter={[16, 16]}>
        //         <Col span={4}>
        //         <Form.Item
        //              colon={false}
        //           name='organizationTypeId'
        //           rules={[
        //             {
        //               required: false,
        //             },
        //           ]}
        //         >
        //           <Select
        //             style={{
        //               width: 160,
        //             }}
        //             className='report-select'
        //             placeholder='Select Organization Type'

        //           >
        //                    {orgTypes.map((types) => {
        //               return (
        //                 <Option key={types.organizationTypeId} value={types.organizationTypeId}>
        //                   {types.organizationType}
        //                 </Option>
        //               );
        //             })}
        //           </Select>
        //         </Form.Item>
        //         </Col>
        //         <Col span={4}>
        //         <Form.Item
                
        //              colon={false}
        //           name='stateId'
        //           rules={[
        //             {
        //               required: false,
        //             },
        //           ]}
        //         >
        //           <Select
        //           className='report-select'
        //             style={{
        //               width: 160,
        //             }}
        //             placeholder='Select State'

        //           >
        //                    {states.map((state) => {
        //               return (
        //                 <Option key={state.stateId} value={state.stateId}>
        //                   {state.name}
        //                 </Option>
        //               );
        //             })}
        //           </Select>
        //         </Form.Item>
        //         </Col>
        //         {/* <Col span={4}>
        //         <Form.Item
        //              colon={false}
        //           name='cityId'
        //           rules={[
        //             {
        //               required: false,
        //             },
        //           ]}
        //         >
        //           <Select
        //             style={{
        //               width: 160,
        //             }}
        //             placeholder='Select City'

        //           >
        //                    {cities.map((city) => {
        //               return (
        //                 <Option key={city.cityId} value={city.cityId}>
        //                   {city.name}
        //                 </Option>
        //               );
        //             })}
        //           </Select>
        //         </Form.Item>
        //         </Col> */}
        //         {/* <Col style={{paddingLeft:"0px",paddingRight:"0px"}} span={4}>
        //         <Form.Item
        //              colon={false}
        //           style={{
        //             width: 550,
        //           }}
        //           name='startDate'
        //           rules={[
        //             {
        //               required: false,
        //               message: 'Please select date!',
        //             },
        //           ]}
        //         >
        //           <DatePicker />
        //         </Form.Item>
        //         </Col>
        //         <Col  style={{paddingLeft:"0px",paddingRight:"0px"}} span={4}>
        //         <Form.Item
        //              colon={false}
        //           name='endDate'
        //           style={{
        //             width: 550,
        //           }}
        //           rules={[
        //             {
        //               required: false,
        //               message: 'Please select date!',
        //             },
        //           ]}
        //         >
        //           <DatePicker />
        //         </Form.Item>
        //         </Col> */}
              
        //         <Col  style={{paddingLeft:"0px",paddingRight:"0px"}} span={3}>
        //         <Form.Item  >
        //          <button type='primary' class='btn btn-primary button' htmlType='submit'>Search</button>
        //         </Form.Item>
        //         </Col>
        //         <Col  style={{paddingLeft:"0px",paddingRight:"0px"}} span={3}>
        //         <CSVLink  icon={faFileExcel} filename={"donation-report.csv"} data={respList}><img style={{marginTop:"-5px"}} src="/excel.png"/></CSVLink>
        //         </Col>
        //       </Row>
             
             
        //       <div class='row'>
        // <div class="col-lg-11 ">
        //     <div class="table-responsive styled-table ">
        //         <table class="table" >
        //             <thead class="thead-light">
        //                 <tr>
        //                     <th>{t("Organization Name")}</th>
        //                     <th>{t("Email")}</th>
        //                     <th>{t("Phone")}</th>
        //                     <th>{t("Address")}</th>
        //                     <th>{t("Status")}</th>
        //                     <th> </th>
        //                 </tr>
        //             </thead>
        //             <tbody>
        //              {renderList?renderList.map((output)=>
        //                 <tr className='row-hover'>
        //                     <td>{output.organizationName}</td>
        //                     <td>{output.email}</td>
        //                     <td>{output.phone}</td>
        //                     <td>{output.address+','+output.city+','+output.state+','+output.country}</td>
        //                     <td>{output.status}</td>
        //                     <td></td>
        //                 </tr>,
        //                ):" "}
        //             </tbody>
        //         </table>
        //     </div>
        // </div>
        // </div>
        // <Pagination style={{marginTop:"10px"}} onChange={onChange} defaultCurrent={current} current={current} total={entriesCount} />
        //     </Form>
        //   </div>
        // </div>
        <div className='ml-3 col-lg-12 col-md-12 col-sm-12 '>
        <div className='row mt-2'>
        <div className="col-lg-12 col-md-10 col-sm-10 fs-3 fw-bold">
        {t('Organization Report')}
        </div>
        <div className='row mt-3 ml-1'>
        <Form
        name='basic'
        form={form}
        className='ml-5'
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 8,
        }}
        style={{ alignItems: 'flexEnd' }}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete='off'
      >
       <Row gutter={[16, 16]}>
      {user.userType==="A"? <Col  style={{paddingLeft:"0px",paddingRight:"0px"}} span={4}>
               <Form.Item
                      colon={false}
                   name='organizationTypeId'
                   rules={[
                     {
                       required: false,
                     },
                   ]}
                 >
                   <Select
                     style={{
                       width: 160,
                     }}
                     className='report-select'
                    placeholder='Select Type'

                   >
                            {orgTypes.map((types) => {
                       return (
                         <Option key={types.organizationTypeId} value={types.organizationTypeId}>
                           {types.organizationType}
                         </Option>
                       );
                     })}
                   </Select>
                 </Form.Item>
         </Col>   :" "} 
         <Col span={4}>
                 <Form.Item
                
                     colon={false}
                  name='stateId'
                  rules={[
                    {
                      required: false,
                    },
                  ]}
                >
                  <Select
                  className='report-select'
                    style={{
                      width: 160,
                    }}
                    placeholder='Select State'

                  >
                           {states.map((state) => {
                      return (
                        <Option key={state.stateId} value={state.stateId}>
                          {state.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                </Col>
                
                <Col  style={{paddingLeft:"0px",paddingRight:"0px"}} span={2}>
         <Form.Item
          colon={false}
          
         >
         <button className='btn btn-primary button' onClick={handleClearClick}>Clear</button>
         </Form.Item>
         </Col>
                <Col  style={{paddingLeft:"0px",paddingRight:"0px"}} span={3}>
                 <Form.Item  >
                  <button type='primary' class='btn btn-primary button' htmlType='submit'>Search</button>
                 </Form.Item>
                 </Col>
         <Col  style={{paddingLeft:"0px",paddingRight:"0px"}} span={3}>
         <CSVLink className='excel-btn'  icon={faFileExcel} filename={"donation-report.csv"} data={renderList}><img style={{marginTop:"-5px"}} src="/excel.png"/></CSVLink>
         {/* <Button><CSVLink  filename={"donation-report.csv"} data={respList}>Export</CSVLink></Button>  */}
         </Col>
       </Row>
       
        </Form>
        {/* <div><b>Total Donations:</b>$ {amount}</div>         */}
        </div>
        {/* <div className="col-lg-2 col-md-2 col-sm-2">
        <button class="btn btn-primary button" onClick={addUser}>Add</button>  
        </div>   */}
        </div>
      <div className='col-lg-11 col-md-12 col-sm-12 '>
      <div class=' styled-table '>
         <table class='table text-black' >
           <thead class='thead-light'>
             <tr>
             {/* <th>{t("ID")}</th> */}
             <th>{t('Name')}</th>
             <th>{t('Type')}</th>
                      <th>{t('Email')}</th>
                      <th>{t('Phone')}</th>
                      <th>{t('Address')}</th>
                      <th>{t('State')}</th>
                       <th>{t('Status')}</th>
                       <th> </th>
             </tr>
           </thead>
           <tbody >

           {renderList
                       ? renderList.map((output) => (
                           <tr className='row-hover'>
                             {/* <td>{output.name}</td> */}
                             <td style={{width:"200px"}}>{output.organizationName?output.organizationName:""}</td>
                             <td style={{width:"70px"}}>{output.organizationType}</td>
                             <td style={{width:"180px"}} >{output.email}</td>
                             <td style={{width:"150px"}}>{output.phone}</td>
                             <td style={{width:"200px"}}>{output.address}</td>
                             <td style={{width:"70px"}}>{output.state}</td>
                             <td style={{width:"70px"}}>{output.status}</td>
                             {/* <td><button type="button" class="btn btn-primary color1 button" onClick={() => editUser(output)}>{t("Edit")}</button></td> */}
                             <td></td>
                           </tr>
                         ))
                       : ' '}
           </tbody>
         </table>
         {renderList&&renderList.length == 0?<NoRecordFound/>:" "}
       </div>
       {/* <Modal show={show} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title className='text-center'>Success</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>  <form>
    <fieldset disabled>
    <div class="form-group mt-2">
      <div className='row '>
        <div className='col-lg-4 mt-1'>Name </div>
        <div className='col-lg-7'><input type="text" id="disabledTextInput" class="form-control " placeholder="Disabled input" value={`${donorObj.firstName} ${donorObj.lastName}`} /></div>
      </div>
    </div>
    </fieldset>
    <fieldset disabled>
    <div class="form-group mt-2">
      <div className='row '>
        <div className='col-lg-4 mt-1'>Email </div>
        <div className='col-lg-7'><input type="text" id="disabledTextInput" class="form-control " placeholder="Disabled input" value={`${donorObj.email}`} /></div>
      </div>
    </div>
    </fieldset>
    <fieldset disabled>
    <div class="form-group mt-2">
      <div className='row '>
        <div className='col-lg-4 mt-1'>Mobile </div>
        <div className='col-lg-7'><input type="text" id="disabledTextInput" class="form-control " placeholder="Disabled input" value={`${donorObj.phone}`} /></div>
      </div>
    </div>
    </fieldset>
    </form></Modal.Body>
                  <Modal.Footer><Button onClick={()=>{setShow(false)}}>Close</Button></Modal.Footer>
                </Modal> */}
      </div>
      <Pagination style={{marginTop:"10px"}} onChange={onChange} defaultCurrent={current} pageSize={10} total={pagesCount} />
      </div>
  );
};

export default OrganizationsReport;
